export const aciMore = {
    iconName: 'more',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M11.987 23.253a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM11.987 6.003a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM11.987 14.628a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
